import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignLanguage } from "@fortawesome/free-solid-svg-icons";
import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo14/Unidad2Actividad8.mp3";

const Actividad8 = () => {
  const infoUnidad = modulo14.content[1];
  const infoAct = modulo14.content[1].activities[10];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title: `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo14.content[1].name}: ${modulo14.content[1].activities[11].name}`,
    linkNext: `${modulo14.url}/${modulo14.content[1].path}/${modulo14.content[1].activities[11].path}`,
    titlePrev: `${modulo14.content[1].name}: ${modulo14.content[1].activities[9].name}`,
    linkPrev: `${modulo14.url}/${modulo14.content[1].path}/${modulo14.content[1].activities[9].path}`,
  };
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo14.color} hat-text`}>
          <FontAwesomeIcon icon={faSignLanguage} /> Hacemos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <div className="row">
        <div className="col-lg-10 col-12">
          <ul>
            <li>Ahora completa la siguiente carta.</li>
            <li>
              Utiliza la información de la Actividad 1 de la Unidad 1 y de la
              Actividad 7 de esta Unidad para completarla.
            </li>
          </ul>
          <div className="row align-items-center my-5 px-4">
            <div className="col-lg-10 col-12">
              <div className="shadow-sm bg-light p-4">
                <div className="d-flex align-items-center mb-2">
                  <p className="mb-0">Ciudad: </p>{" "}
                  <input type="text" className="form-control ms-2 form-carta" />
                </div>
                <div className="d-flex align-items-center mb-5">
                  <p className="mb-0">Fecha: </p>{" "}
                  <input type="date" className="form-control ms-2 form-carta" />
                </div>
                <p>Estimados señores del Ministerio de Educación:</p>
                <p>
                  Los estudiantes de 3er grado creemos que es importante
                  aprender castellano en la escuela, pero también es importante
                  aprender las lenguas originarias de nuestro país.
                </p>
                <div className="d-flex align-items-center mb-2">
                  <p className="mb-0">Mi compañero, compañera o familiar</p>{" "}
                  <input
                    type="text"
                    className="form-control ms-2 form-carta-1"
                  />
                </div>
                <div className="d-flex align-items-center mb-2">
                  <p className="mb-0">propone que aprendamos la lengua</p>{" "}
                  <input
                    type="text"
                    className="form-control ms-2 form-carta-1"
                  />
                  .
                </div>
                <div className="d-flex align-items-center mb-2">
                  <p className="mb-0">
                    Esta lengua se habla en el(los) departamento(s) de
                  </p>{" "}
                  <input type="text" className="form-control ms-2 form-carta" />
                </div>
                <div className="d-flex align-items-center mb-2">
                  <input type="text" className="form-control" />
                </div>
                <div className="d-flex align-items-center mb-2">
                  <p className="mb-0">Sería bueno aprenderla porque</p>{" "}
                  <input
                    type="text"
                    className="form-control ms-2 form-carta-1"
                  />
                </div>
                <div className="d-flex align-items-center mb-2">
                  <input type="text" className="form-control" />
                </div>
                <div className="d-flex align-items-center mb-2">
                  <p className="mb-0">Yo propongo que aprendamos la lengua</p>{" "}
                  <input type="text" className="form-control ms-2 form-carta" />
                </div>
                <div className="d-flex align-items-center mb-2">
                  <input type="text" className="form-control" />
                </div>
                <div className="d-flex align-items-center mb-2">
                  <p className="mb-0">que se habla en</p>{" "}
                  <input
                    type="text"
                    className="form-control ms-2 form-carta-1"
                  />
                </div>
                <div className="d-flex align-items-center mb-2">
                  <input type="text" className="form-control form-carta" />{" "}
                  <p className="mb-0">. Hablar esta lengua nos permitiría</p>
                </div>
                <div className="d-flex align-items-center mb-2">
                  <input type="text" className="form-control" />
                  {"."}
                </div>
                <div className="mb-4">
                  <p>Atentamente,</p>
                </div>
                <div className="d-flex justify-content-end mb-2">
                  <input type="text" className="form-control w-200" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Lea las indicaciones: Ahora completa la siguiente carta. Utiliza la
            información de la Actividad 1 y la Actividad 7 de la unidad 2 para
            completarla. Antes de comenzar, explique lo
            siguiente:{" "}
            <i>
              “Primero escribirán la ciudad en la que estamos y la fecha de hoy.
              Ahora leeremos la primera parte”.
            </i>
          </li>
          <li>
            <i>
              {" "}
              “Ahora deberán regresar a la Actividad 7 y llenar el nombre de su
              compañero o compañera y el nombre de la lengua que escogió.
              Después, vayan a la Actividad 1 de la Unidad 2 y vean en el mapa
              en dónde se habla esa lengua. Regresen a la actividad 8 y escriban
              las razones dadas por su compañero o compañera para aprender esa
              lengua”. “En el siguiente espacio de la carta harán lo mismo con
              la lengua que ustedes escogieron”.
            </i>
          </li>
          <li>
            Dé un tiempo para que trabajen y luego, pida a
            algunos(as) que lean sus cartas.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad8;
